// SPDX-License-Identifier: BUSL-1.1

import { apiFetch } from '@/lib/api-client';

export interface OrganizationSummary {
  id: string;
  name: string;
  slug: string;
  status: string;
  membershipRole?: string | null;
}

export async function createOrganization(input: {
  name: string;
  slug: string;
}): Promise<OrganizationSummary> {
  const result = await apiFetch<{ data: OrganizationSummary }>('/orgs/self', {
    method: 'POST',
    body: JSON.stringify(input),
  });
  return result.data;
}
